import { Button } from "@devhop/ui";
import { PlusIcon } from "lucide-react";

type RoomBookingsToolbarProps = {
  canManage?: boolean;
  onCreate: () => void;
  onBulkCreate?: () => void;
};

export function RoomBookingsToolbar({
  canManage,
  onCreate,
  onBulkCreate,
}: RoomBookingsToolbarProps) {
  return (
    <div className="mb-2 flex flex-wrap items-center justify-between space-y-2">
      <div>
        <h2 className="flex items-center font-bold text-2xl tracking-tight">
          ການຈອງຫ້ອງ
        </h2>
        <p className="text-muted-foreground">
          ຈັດການການຈອງຫ້ອງ (ຈອງ / ເຊົ່າຫ້ອງ) ໃນລະບົບ.
        </p>
      </div>
      {canManage && (
        <div className="flex items-center space-x-2">
          {onBulkCreate && (
            <Button variant="outline" onClick={onBulkCreate}>
              ຈອງຫຼາຍຄັ້ງ
            </Button>
          )}
          <Button onClick={onCreate}>
            <PlusIcon className="h-4 w-4" />
            ສ້າງການຈອງຫ້ອງ
          </Button>
        </div>
      )}
    </div>
  );
}
